import React, { useCallback, useEffect, useState } from "react";
import api from "../services/api";
import axios, { Canceler } from "axios";
import SCAutoComplete from "./form/autocomplete/SCAutoComplete";
import SCDropdown from "./form/dropdown/SCDropdown";

let cancel: Canceler;

type Props = any;

const SelectCentroCusto: React.FC<Props> = ({
  name,
  control,
  errors,
  label,
  setError,
  clearErrors,
  setValue,
  minLength = 3,
  ...props
}) => {
  const [lista, setLista] = useState<any>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    try {
      api.get("/centroCusto/combo").then((response) => {
        setLista(response.data);
        setLoading(false);
      });
    } catch (error) {
      console.error("Erro ao buscar centros de custo:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <SCDropdown
      loading={loading}
      name={name}
      label={label}
      control={control}
      errors={errors}
      options={lista}
      showFilterClear
      filterBy="Descricao"
      optionLabel="Descricao"
      optionValue="CentroCustoId"
      {...props}
    />
  );
};

export default SelectCentroCusto;
